import { render, staticRenderFns } from "./ItemFilterLink.vue?vue&type=template&id=a148f93c&scoped=true&"
import script from "./ItemFilterLink.vue?vue&type=script&lang=js&"
export * from "./ItemFilterLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a148f93c",
  null
  
)

export default component.exports